// const ImageUrl="http://localhost/public";
const ImageUrl="https://microfinance.goldenglobal.in/backend/public";

export default ImageUrl;